import { Link, useLocation } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';
import { useDashboardStats } from '@/hooks/useDashboardStats';

const DashboardNavLink = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { totalPending } = useDashboardStats();
  
  if (!user) return null;
  
  const isActive = location.pathname === '/dashboard';
  
  return (
    <Link
      to="/dashboard"
      className={cn(
        "flex items-center gap-2 px-3 py-2 h-9 rounded-lg transition-all font-medium text-sm relative",
        isActive 
          ? "bg-white/60 text-primary" 
          : "text-primary/80 hover:text-primary hover:bg-white/50"
      )}
    >
      <Activity className="h-4 w-4" />
      <span>My Activity</span>
      {totalPending > 0 && (
        <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white ring-2 ring-white">
          {totalPending > 9 ? '9+' : totalPending}
        </span>
      )}
    </Link>
  );
};

export default DashboardNavLink;
